import React, { FC } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'

interface IProps {
  show: boolean
  onClose: () => void
  onDeactivate: () => void
  onKeepActive: () => void
  oldPrice: string
  newPrice: string
  specialPrice: string
}

const SpecialPriceDecisionModal: FC<IProps> = ({
  show,
  onClose,
  onDeactivate,
  onKeepActive,
  oldPrice,
  newPrice,
  specialPrice,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({ id: 'special_price_update_title' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{formatMessage({ id: 'special_price_update_message' })}</p>
          <div style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>{formatMessage({ id: 'current_base_price' })}:</strong> {oldPrice}
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>{formatMessage({ id: 'new_base_price' })}:</strong> {newPrice}
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>{formatMessage({ id: 'current_special_price' })}:</strong> {specialPrice}
            </div>
          </div>
          <p style={{ marginTop: '15px', fontWeight: 'bold' }}>
            {formatMessage({ id: 'special_price_choose_option' })}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {formatMessage({ id: 'cancel' })}
        </Button>
        <Button variant="warning" onClick={onDeactivate}>
          {formatMessage({ id: 'deactivate_special_price' })}
        </Button>
        <Button variant="primary" onClick={onKeepActive}>
          {formatMessage({ id: 'keep_special_price_active' })}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SpecialPriceDecisionModal
